import React from "react";
import "../sass/Content.scss";

const Terms = () => {
  return (
    <div className="legalWrapper">
      <h1>TERMS OF USE</h1>
      <p>Last updated: December 16th, 2021 </p>

      <p>
        By accessing and using this site, you accept the following terms and
        conditions, without limitation or qualification:
      </p>

      <ul>
        <li>
          These Terms of Service (“Terms”, “Terms of Service”) govern your use
          of this website www.skyserve.ai (“Website”) operated by SkyServe Inc.
          (“SkyServe”, “we”, “our”, “us”). These Terms apply to all visitors,
          users, and others who wish to access or use the Website.
        </li>
        <li>
          Please carefully read these Terms of Service and other policies on the
          Website, before you (“you/Customer, User”) decide to access the
          Website or avail of the services made available on the Website by us.
        </li>
        <li>
          By using this Website or other Services provided by us (“Services”),
          you acknowledge that you have read these Terms of Service, and you
          irrevocably accept all the conditions stipulated in the Terms of Use
          and Privacy Policy (collectively “Policies”) as available on the
          Website and agree to abide by them.
        </li>
        <li>
          You agree to comply with and be bound by these terms and conditions
          (“Terms of Use”), which together with our privacy policy (“Privacy
          Policy”) govern EarthSights relationship with you.
        </li>
        <li>
          <h3>DEFINITIONS</h3>
          <ul>
            <li>
              “Product” or “Products” shall mean one or more of: the
              satellite/aerial images, data/insights, software services, and
              developer kits sold by SkyServe Inc to you.
            </li>
            <li>
              “Platform/Application” shall mean and include the application
              programming interface that allows you to search, view, and access
              Products provided by EarthSights.
            </li>
          </ul>
        </li>
        <li>
          <h3>PROHIBITED USES</h3>
          <ul>
            <li>
              You may use our Website/ Application only for lawful purposes and
              in accordance with the Terms. You agree not to use it:
              <ul>
                <li>
                  In any way that violates any applicable law or regulation.
                </li>
                <li>
                  For the purpose of exploiting, harming, or attempting to
                  exploit or harm minors in any way by exposing them to
                  inappropriate content or otherwise.
                </li>
                <li>
                  To transmit, or procure the sending of, any advertising or
                  promotional material, including any “junk mail”, “chain
                  letter,” “spam,” or any other similar solicitation.
                </li>
                <li>
                  To impersonate or attempt to impersonate us, our employee,
                  another user, or any other person or entity.
                </li>
                <li>
                  In any way that infringes upon the rights of others, or in any
                  way is illegal, threatening, fraudulent, or harmful, or in
                  connection with any unlawful, illegal, fraudulent, or harmful
                  purpose or activity.
                </li>
                <li>
                  To engage in any other conduct that restricts or inhibits
                  anyone's use or enjoyment of the Website, or which, as
                  determined by us, may harm or offend us or other users of
                  Website or expose them to liability.
                </li>
              </ul>
            </li>
            <li>
              Additionally, you agree not to:
              <ul>
                <li>
                  Use the Website/ Application in any manner that could disable,
                  overburden, damage, or impair or interfere with any other
                  Party’s use of the Website.
                </li>
                <li>
                  Use any robot, spider, or another automatic device, process,
                  or means to access the Website/ Application for any purpose.
                </li>
                <li>
                  Use any manual process to monitor or copy any of the material
                  on the Website/ Application or for any other unauthorized
                  purpose without our prior written consent.
                </li>
                <li>
                  Use any device, software, or routine that interferes with the
                  proper working of the Website/ Application.
                </li>
                <li>
                  Introduce any viruses, trojan horses, worms, logic bombs, or
                  other material which is malicious or technologically harmful.
                </li>
                <li>
                  Attempt to gain unauthorized access to, interfere with,
                  damage, or disrupt any parts of the Website, the server on
                  which the Website/ Platform is stored, or any server,
                  computer, or database connected to the Website/ Application.
                </li>
                <li>
                  Attack the Website/Platform via a denial-of-service attack or
                  a distributed denial-of-service attack.
                </li>
                <li>
                  Take any action that may damage or falsify our reputation.
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <h3>REGISTRATION</h3>
          <ul>
            <li>
              By registering for an account on the Platform, you represent and
              warrant that you are the age of majority (age 18).
            </li>
            <li>
              You agree to:
              <ul>
                <li>
                  provide true, correct, accurate, and current information about
                  yourself,
                </li>
                <li>
                  maintain the security of your passwords and identification,
                </li>
                <li>
                  promptly update the email address listed in connection with
                  your account to keep it accurate so that we can contact you at
                  any point in time, and
                </li>
                <li>
                  be fully responsible for the use of your account. You shall
                  not set up an account on behalf of another individual or
                  entity unless you are authorized to do so.
                </li>
              </ul>
            </li>
            <li>
              You agree to abide by all applicable laws and regulations and are
              solely responsible for all acts or omissions by you on the
              Account.
            </li>
            <li>
              You agree to immediately notify EarthSights of any unauthorized
              use of your password or email address or any breach of security of
              which you have become aware;
            </li>
            <li>
              Termination: We reserve the right to modify or discontinue your
              account at any time for any material breach under these Terms of
              Use by you or any other reason at its sole discretion without any
              liability whatsoever.
            </li>
          </ul>
        </li>
        <li>
          <h3>CONTENT AVAILABLE</h3>
          <p>
            EarthSights does not make any representations or warranties about
            the material, data, and information, that is or may be shared on the
            Website/Application (collectively, the “Content”) which you may have
            access to as part of the Services, or through your use of this
            Application. Under no circumstances, are we liable for any Content,
            including, but not limited to any infringing Content, any errors or
            omissions in Content, or for any loss or damage of any kind incurred
            as a result of the use of any Content posted, transmitted, linked
            from, or otherwise accessible through or made available via the
            Application.
          </p>
        </li>
        <li>
          <h3>INTELLECTUAL PROPERTY RIGHT</h3>
          <ul>
            <li>
              Any and all intellectual property rights ("Intellectual Property")
              associated with the Product, Website, Application and its contents
              are the sole property of EarthSights. All customised graphics,
              icons, and other items that appear on the Website/Application are
              trademarks, service marks or trade name of EarthSights. Except as
              otherwise expressly authorised by these Terms of Use, You shall
              not copy, reproduce, modify, amend, lease, loan, sell and/or
              create derivative works from, upload, transmit, and/or distribute
              the Intellectual Property of the Website, Application and Product
              in any way without EarthSights prior written consent. Except as
              expressly provided herein, EarthSights does not grant you any
              express or implied rights to the Intellectual Property of
              EarthSights or that of any third party.
            </li>
            <li>
              If you are a copyright owner, or authorized on behalf of one, and
              you believe that the copyrighted work has been copied in a way
              that constitutes copyright infringement, please submit your claim
              via email to hello@skyserve.ai, with the subject line: “Copyright
              Infringement”.
            </li>
            <li>
              You shall be held accountable for damages (including costs and
              attorneys’ fees) for misrepresentation or claims on the
              infringement of any Content found on and/or through Service on
              your copyright.
            </li>
          </ul>
        </li>
        <li>
          <h3>CHANGE IN TERMS</h3>
          <p>
            EathSights reserves the right to change these Terms of Use at any
            time and to notify you by posting an updated version of the Terms of
            Use on the Website. You are responsible for regularly reviewing the
            Terms of Use. Continued use of the Platform/ Website after any such
            changes shall constitute your consent to be bound by such changes.
            Your right with respect to any dissatisfaction with these Terms of
            Use; any policy or practice of ours in operating the Platform or any
            Content available through the Application, is to stop accessing and
            using the Application.
          </p>
        </li>
        <li>
          <h3>DISCLAIMER OF WARRANTIES</h3>
          <p>
            YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE PLATFORM AND THE
            SERVICE IS ENTIRELY AT YOUR OWN RISK AND THAT THE PLATFORM AND THE
            SERVICES THEREIN ARE PROVIDED ON AN "AS IS" OR "AS AVAILABLE" BASIS,
            WITHOUT ANY WARRANTIES OF ANY KIND. ALL EXPRESS AND IMPLIED
            WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT OF PROPRIETARY RIGHTS ARE EXPRESSLY DISCLAIMED TO
            THE FULLEST EXTENT PERMITTED BY LAW.
          </p>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY LAW EARTHSIGHTS, ITS OFFICERS,
            DIRECTORS, EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR
            IMPLIED, IN CONNECTION WITH THE PLATFORM, THE SERVICES AND YOUR USE
            THEREOF.
          </p>
          <p>
            EARTHSIGHTS MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE
            ACCURACY OR COMPLETENESS OF THE SERVICES OR THE PLATFORM 'S CONTENT
            OR THE CONTENT OF ANY THIRD PARTY WEBSITES LINKED TO THE PLATFORM
            AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS,
            MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR
            PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
            ACCESS TO AND USE OF THE PLATFORM AND SERVICE, (III) ANY
            UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY AND ALL
            PERSONAL INFORMATION, (IV) ANY INTERRUPTION OR CESSATION OF
            TRANSMISSION TO OR FROM THE PLATFORM, (IV) ANY BUGS, VIRUSES, TROJAN
            HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE
            PLATFORM BY ANY THIRD PARTY, AND/OR (V) ANY ERRORS OR OMISSIONS IN
            ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
            RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, COMMUNICATED,
            TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE PLATFORM OR THE
            SERVICE.
          </p>
          <p>
            EARTHSIGHTS DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
            RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A
            THIRD PARTY THROUGH THE PLATFORM OR ANY HYPERLINKED WEBSITE OR
            FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND EARTHSIGHTS WILL
            NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
            TRANSACTION BETWEEN YOU AND/OR OTHER MERCHANT AND/OR THIRD-PARTY
            SERVICE PROVIDERS.
          </p>
          <p>
            THE PLATFORM MAY ALSO CONTAIN THIRD-PARTY ADVERTISEMENTS IF ANY. THE
            DISPLAY OF SUCH ADVERTISEMENTS DOES NOT IN ANY WAY IMPLY AN
            ENDORSEMENT OR RECOMMENDATION BY OF THE RELEVANT ADVERTISER, ITS
            PRODUCTS, OR SERVICES. YOU ARE REFERRED TO THE RELEVANT ADVERTISER
            FOR ALL INFORMATION REGARDING THE ADVERTISEMENT AND ITS PRODUCTS
            AND/OR SERVICES. EARTHSIGHTS ACCEPTS NO RESPONSIBILITY FOR ANY
            INTERACTION BETWEEN YOU AND THE RELEVANT THIRD PARTY AND IS RELEASED
            FROM ANY LIABILITY ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH
            INTERACTION.
          </p>
        </li>
        <li>
          <h3>LIMITATION OF LIABILITY</h3>
          <p>
            IN NO EVENT SHALL EARTHSIGHTS, ITS OFFICERS, DIRECTORS, EMPLOYEES,
            OR AGENTS, BE LIABLE FOR DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL OR EXEMPLARY DAMAGES (EVEN IF EARTHSIGHTS HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM YOUR USE
            OF THE PLATFORM OR THE SERVICE, INCLUDING BUT NOT LIMITED TO THE
            DAMAGES THAT MAY ARISE FROM YOUR USE OR MISUSE OF THE PLATFORM OR
            THE SERVICE, FROM INABILITY TO USE THE PLATFORM OR THE SERVICE, OR
            THE INTERRUPTION, SUSPENSION, MODIFICATION, ALTERATION, OR
            TERMINATION OF THE PLATFORM OR THE SERVICE. SUCH LIMITATION OF
            LIABILITY SHALL ALSO APPLY WITH RESPECT TO DAMAGES INCURRED BY THE
            USE OF THIRD-PARTY SERVICES OR LINKS ADVERTISED IN THE PLATFORM OR
            THROUGH ANY INFORMATION, OPINION OR ADVICE RECEIVED THROUGH SUCH
            LINKS OR USE OF SERVICES BY A THIRD PARTY
          </p>
          <p>
            THESE LIMITATIONS SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY
            LAW. YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT EARTHSIGHTS SHALL
            NOT BE LIABLE FOR CONTENTS THAT ARE DEFAMATORY, OFFENSIVE OR FOUND
            ILLEGAL.
          </p>
        </li>
        <li>
          <h3>INDEMNIFICATION</h3>
          <p>
            You agree to indemnify us and hold us harmless from and against any
            claims arising out of or relating to all actions, proceedings,
            claims (including third party claims), liabilities (including
            statutory liability), penalties, charges, demands, and costs
            (including without limitation, legal costs of the other Party),
            awards, damages, losses and/or expenses however arising directly or
            indirectly or consequentially suffered or incurred by the user as a
            result of any breach or non-performance of their respective
            undertaking/s, warranties:
          </p>

          <ul>
            <li>
              Information, details, and content that you submit or transmit for
              the Services
            </li>
            <li>
              your violation of any rights of other users in relation to the
              Application,
            </li>
            <li>
              infringement of any third-party intellectual property rights,
            </li>
            <li>any breach of terms and conditions of these Terms of Use, </li>
            <li>any breach of applicable law. </li>
          </ul>
        </li>

        <li>
          <h3>ANTI-SPAM POLICY</h3>
          <p>
            You certify that you will use the Services in accordance with these
            Terms of Use. You are forbidden to transmit unsolicited commercial
            email (spam) by using the Services. Additionally, You are required
            to reconfirm (permission pass) or stop mailing an existing list when
            it is determined to be in violation of our anti-spam policy.
            Repeated violations or failures to comply with this anti-spam policy
            will result in termination of your access to the Services. You agree
            and acknowledge that, we shall not be held liable for any claim that
            may arise due to your violation of this anti-spam policy.
          </p>
        </li>

        <li>
          <h3>GOVERNING LAW</h3>
          <p>
            These Terms of Use are governed and construed according to the laws
            of Delaware and the Courts in Delaware shall have exclusive
            jurisdiction to entertain any proceedings in any way relating to or
            concerning these Terms of Use.
          </p>
        </li>

        <li>
          <h3>FORCE MAJEURE</h3>
          <p>
            Without limiting the foregoing, under no circumstances shall
            EarthSightsis held liable for any damage or loss due to deficiency
            in performance of Services resulting directly or indirectly from
            acts of nature, forces, or causes beyond its reasonable control,
            including, without limitation to internet failures, computer
            equipment failures, telecommunication equipment failures, software
            failures, machinery breakdown, strike, or due to government
            regulations, floods, storms, pandemic, epidemic, electrical failure,
            civil disturbances, riots and any other reason beyond reasonable
            control of the Merchant or the Application.
          </p>
        </li>

        <li>
          <h3>ERROR REPORTING AND FEEDBACK</h3>
          <p>
            In case of any technical issues or feedback (“Feedback”), please
            sending us your queries at hello@skyserve.ai. You acknowledge and
            agree that: (i) you shall not retain, acquire or assert any
            intellectual property right or other right, title or interest in or
            to the Feedback; (ii) EarthSights may have development ideas similar
            to the Feedback; (iii) Feedback does not contain confidential
            information or proprietary information from you or any third party;
            and (iv) EarthSights is not under any obligation of confidentiality
            with respect to the Feedback. In the event the transfer of the
            ownership to the Feedback is not possible due to applicable
            mandatory laws, you grant EarthSights and its affiliates an
            exclusive, transferable, irrevocable, free-of-charge,
            sub-licensable, unlimited and perpetual right to use (including
            copy, modify, create derivative works, publish, distribute and
            commercialize) Feedback in any manner and for any purpose
          </p>
        </li>
      </ul>
    </div>
  );
};

export default Terms;
